import styled from 'styled-components'

// Components
import { Text } from 'modules/workspace/views/WorkspaceSubscribeView/WorkspaceSubscribeView.styles'

// Utils
import { breakpoint } from 'utils'

// Icons
import { ReactComponent as QuestionMarkIconUnstyled } from 'icons/question-mark-16.svg'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Container = styled.div`
  display: grid;
  grid-template-columns: 448px 450px;
  grid-column-gap: 146px; /* stylelint-disable-line scales/space */
  margin: 0 auto;

  ${breakpoint('base', 'lg')`
    grid-template-columns: auto;
  `}
`

export const PlanPickerWrapper = styled.div`
  margin-top: 24px;
`

export const Section = styled.section`
  margin-bottom: 40px;
`

export const BillSummaryWrapper = styled.section`
  margin-bottom: 24px;

  ${breakpoint('base', 'sm')`
    margin-top: 32px;
  `}
`

export const TextWithTooltip = styled(Text)`
  display: flex;
  line-height: 1.4;

  ${breakpoint('base', 'xs')`
    display: inline-block;
    max-width: 295px;
  `}
`

export const TooltipContainer = styled.span`
  display: inline-block;
  margin-left: 4px;
`

export const TooltipBodyWrapper = styled.div`
  width: 300px;
`

export const TooltipText = styled.p`
  margin: 0 0 8px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.foreground.primary[2]};

  :last-child {
    margin: 0;
  }

  b {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.foreground.primary[1]};
  }
`
export const QuestionMarkIcon = styled(QuestionMarkIconUnstyled)`
  width: 16px;
  cursor: pointer;
`
